import { mergeStyles } from '../../../component-themes';
const featureListItemIconBase = (tokens) => ({ variant }) => mergeStyles([
    {
        color: tokens.styles[`featureList-feature-content-header-icon-${variant}-background`],
        opacity: tokens.styles[`featureList-feature-content-header-icon-${variant}-opacity`],
    },
]);
export const featureListItemIcon = (tokens) => ({ variant }) => featureListItemIconBase(tokens)({ variant });
